module.exports = __webpack_public_path__ + "img/gemFollowed.c5373747.svg";